<template>
    <div
        ref="root"
    >
        <WujieVue v-if="enabled" v-bind="getOptions()" class="h-full"/>
    </div>
</template>

<script setup lang="ts">
import WujieVue from 'wujie-vue3';
import { withDefaults } from 'vue';
import type { PatsnapCopilotService } from '@analytics/patsnap-copilot/src/patsnap-copilot-service.interface';
import { useCopilotUsage } from '@analytics/patsnap-copilot/src/components/composables/use-copilot-usage';
import { wujieOptions } from '@analytics/patsnap-copilot/src/copilot';
import { CopilotPlan } from '@analytics/patsnap-copilot/src/patsnap-copilot-service.interface';

const { enabled, patsnapCopilotUsage } = useCopilotUsage();
const appName = 'eureka:project-chat'

const props = withDefaults(defineProps<{
    service?: PatsnapCopilotService;
    url: string;
}>(), {
    service: undefined,
});

function getOptions() {
    const options = wujieOptions({
        service: props.service,
        url: props.url,
        patsnapCopilotUsage: {
            ...patsnapCopilotUsage.value,
            // 白板输入框可以自由问答不受限
            plan: CopilotPlan.B,
        },
    });
    return {
        ...options,
        name: appName,
    };
}
</script>
